import { render, staticRenderFns } from "./DebugOverview.vue?vue&type=template&id=54bc01ba&"
import script from "./DebugOverview.vue?vue&type=script&lang=js&"
export * from "./DebugOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports